module.exports = __webpack_public_path__ + "static/media/kino35.7a9c3ef4.png";